import React, {useEffect, useState} from 'react';
import "./NewCampaignStats.css";
import "./NewCampaignStatsAdditional.css";
import 'primeicons/primeicons.css';
import comingSoonImage from "../img/coming-soon-img.png";
import { Button } from "primereact/button";
import { CampaignStatus } from "@/data/types";
import {
  BackIcon, CheckMark, CloseIcon, ClicksIcon, CommentsIcon, PencilIconRed,
  ViewsIcon, WhiteAppleIcon, WhiteAndroidIcon, LikesIcon, CopyIconMenu,
} from "@/react_app/img/Icons";
import { Image } from "primereact/image";
import NewCreateCampaign from "@/react_app/NewCreateCampaign/NewCreateCampaign";
import { Dialog } from "primereact/dialog";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';
import { paymentMethodsOptions } from "@/pages/campaigns/create/data.campaign";
import { useCampaigns, usePage } from "@/modules";
import { PaymentMethodDisplay, OtherUrlIcon, tabs, TabStep } from "@/react_app/NewCampaignStats/NewCampaignStatsAdditional";
import {
  commentBodyTemplate, likesBodyTemplate, viewsBodyTemplate, dateBodyTemplate, statusBodyTemplate, videoBodyTemplate
} from "@/react_app/NewCampaignStats/NewCampaignStatsAdditional";

const getUrlName = (index) => {
  if (index === 0) {
    return 'Google Play Link';
  } else if (index === 1) {
    return 'Apple App Store Link';
  }
  return 'Product Website Link';
}

export default function(props){
  const [activeTab, setActiveTab] = useState(0);
  const [filteredAttachments, setFilteredAttachments] = useState([]);
  const [editCampaign, setEditCampaign] = useState(true);
  const [warningCopyModal, setWarningCopyModal] = useState(false);
  const [warningCloseModal, setWarningCloseModal] = useState(false);

  const [totalViews, setTotalViews] = useState(0);
  const [totalClicks, setTotalClicks] = useState(0);
  const [totalLikes, setTotalLikes] = useState(0);
  const [totalComments, setTotalComments] = useState(0);
  const [totalInstallsAndroid, setTotalInstallsAndroid] = useState(0);
  const [totalInstallsIOS, setTotalInstallsIOS] = useState(0);
  const [statisticsItemsNumber, setStatisticsItemsNumber] = useState(6);

  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  const statisticsItems = [
    {
      title: 'Total Views',
      icon: <ViewsIcon />,
      value: totalViews,
    },
    {
      title: 'Total Clicks',
      icon: <ClicksIcon />,
      value: totalClicks,
    },
    {
      title: 'Total Likes',
      icon: <LikesIcon />,
      value: totalLikes,
    },
    {
      title: 'Total Comments',
      icon: <CommentsIcon />,
      value: totalComments,
    },
    {
      title: 'Total Installs Android',
      icon: <WhiteAndroidIcon />,
      value: totalInstallsAndroid,
    },
    {
      title: 'Total Installs iOS',
      icon: <WhiteAppleIcon />,
      value: totalInstallsIOS,
    },
  ];

  useEffect(() => {
    if(props.campaign) {
      setFilteredAttachments(props.campaign.attachments.filter(file => file.type?.startsWith('image/')));
      setTotalInstallsAndroid(props.campaign.totalCampaignInstalls.android);
      setTotalInstallsIOS(props.campaign.totalCampaignInstalls.ios);
      setTotalClicks(props.campaign.totalCampaignClicks);
      if(props.campaign.paymentMethod !== paymentMethodsOptions.CPI) {
        setStatisticsItemsNumber(4);
      }
    }

    const data = {
      labels: ['Amount Spent', 'Current Amount'],
      datasets: [
        {
          data: [props.campaign?.budget.amount - props.campaign?.budget.amountLeft, props.campaign?.budget.amountLeft],
          backgroundColor: ['#E73D38', '#130A23'],
          borderWidth: 0,
        },
      ],
    };

    const options = {
      cutout: '70%',
      plugins: {
        legend: {
          display: false,
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, [props.campaign]);

  useEffect(() => {
    if(props.liveContentItems) {
      props.liveContentItems.forEach((item) => {
        setTotalViews((prevTotalViews) => prevTotalViews + parseInt(item.statistics.viewCount));
        setTotalComments((prevTotalComments) => prevTotalComments + parseInt(item.statistics.commentCount));
        setTotalLikes((prevTotalLikes) => prevTotalLikes + parseInt(item.statistics.likeCount));
      });
    }
  }, [props.liveContentItems]);

  const { config } = usePage({ title: 'create campaign' });
  const page = useCampaigns(config?.value?.viewPerspective);

  const createDraft = async (pushRouter) => {
    const createdDraft = await page.manager.create(props.campaign);
    if (props.campaign.attachments?.length) {
      const formData = new FormData();
      for await (const file of props.campaign.attachments) {
        formData.set('files[]', file);
        await page.manager.attachments(createdDraft?.id, formData);
      }
    }
    if (pushRouter) {
      await props.pushDraft(createdDraft);
    }
    return createdDraft;
  };

  const copyCampaign = async () => {
    await createDraft(false).then(async (createdCampaign) => {
      if (createdCampaign?.id) {
        await page.manager.pending(createdCampaign?.id);
      }
    });
  };

  return (
    <div className={'campaign-stats'}>
      <div className={'navigationMenu'}>
        <div className={'goBack'} onClick={() => props.handleReturn()}>
          <BackIcon/>
          <span className={'goBackText'}>Campaign Management</span>
        </div>
        <div className={'menuCampaignInfo'}>
          <Image src={props.campaign?.photo} alt={'campaign cover'} className={'menuCampaignCover'}/>
          <p className={'menuCampaignName'}>{props.campaign?.name}</p>
        </div>
        <div className={'menuTabsWrapper'}>
          <div className={'menuTabs'}>
            {tabs.map((item, index) =>
              <div key={index} className={activeTab === index ? 'menuTabSelected' : 'menuTabNormal'} onClick={()=> setActiveTab(index)}>
                {activeTab === index ? item.iconSelected : item.iconNormal}
                <span className={'menuTabText'}>{item.title}</span>
              </div>)}
            <div className={'menuTabNormal'} onClick={()=> setWarningCopyModal(true)}>
              <CopyIconMenu/>
              <span className={'menuTabText'}>Copy Campaign</span>
            </div>
            {props.campaign?.status !== CampaignStatus.Completed &&
              <div  className={'closeCampaign'}>
                <div className={'menuTabNormal'} onClick={()=> setWarningCloseModal(true)}>
                  <CloseIcon/>
                  <span className={'menuTabText'}>Close Campaign</span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      {activeTab === TabStep.Details &&
        (editCampaign ?
          <div className={'campaignDetails'}>
            <div className={'coverBackground'} style={{ background: `linear-gradient(rgba(19, 10, 35, 0.7), rgba(19, 10, 35, 0.7)), url(${props.campaign?.photo})` }}>
              <p className={'coverTitle'}>{props.campaign?.name}</p>
              <div className={'coverGrid'}>
                <div>
                  <p className={'coverLabel'}>Category:</p>
                  <p className={'coverValue'}>{props.campaign?.targetMarket.title}</p>
                </div>
                <div>
                  <p className={'coverLabel'}>Campaign {props.campaign?.paymentMethod}:</p>
                  <PaymentMethodDisplay campaign={props.campaign}/>
                </div>
                <div>
                  <p className={'coverLabel'}>Application time left:</p>
                  <p className={'coverValue'}>{props.campaign?.dates.endDate ? new Date(props.campaign.dates.endDate).toLocaleDateString
                  ('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Until budget is complete'}</p>
                </div>
                <div>
                  <p className={'coverLabel'}>Region:</p>
                  <p className={'coverValue'}>{props.campaign?.desiredRegions[0]?.value}</p>
                </div>
              </div>
              <Button label="Edit Campaign" className={'editButtonTransparent'} onClick={() => setEditCampaign(false)}>
                <PencilIconRed/>
              </Button>
            </div>
            <div className={'infoMain'}>
              <div className={'infoMainLeft'}>
                <div>
                  <p className={'infoLabel'}>Campaign Details</p>
                  <p className={'infoText'}>{props.campaign?.productName}</p>
                </div>
                <div>
                  <p className={'infoLabel'}>Talking points</p>
                  <div className={'talkingPointsWrapper'}>
                    {props.campaign?.talkingPoints?.filter(item => item !== '').map((item, index) =>
                      <div key={index} className={'talkingPoint'}>
                        <CheckMark />
                        <div className={'talkingPointText'}>
                          {item}
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
              <div className={'infoMainRight'}>
                <div>
                  <p className={'infoLabel'}>Campaign URls</p>
                  <div className={'linkWrapper'}>
                    {props.campaign?.productUrls?.map((item, index) =>
                      <div key={index}>
                        <p className={'linkLabel'}>{getUrlName(index)}</p>
                        <div className={'link'}>
                          <OtherUrlIcon index={index}/>
                          <span className={'overflowEllipsis'}>{item.value}</span>
                        </div>
                      </div>)}
                  </div>
                </div>
                <div>
                  <p className={'infoLabel'}>Call to Action</p>
                  <div className={'callToActionBox'}>{props.campaign?.callToAction}</div>
                </div>
                <div>
                  <p className={'infoLabel'}>Attachments</p>
                  <div className={'attachmentsWrapper'}>
                    {filteredAttachments.slice(0,3).map((item, index) =>
                      <Image key={index} src={item.objectURL} alt={'attachment image'} className={'attachmentImage'}/>)}
                  </div>
                </div>
              </div>
            </div>
            <div className={'buttonGroup'}>
              {props.campaign?.status !== CampaignStatus.Completed && <Button className={'closeButton'} onClick={() => setWarningCloseModal(true)}>Close Campaign</Button>}
              <Button className={'editButtonPrimary'} onClick={() => setEditCampaign(false)}>Edit Campaign</Button>
            </div>
          </div> :
          <div className={'createCampaignWrapper'}>
            <NewCreateCampaign campaign={props.campaign} isCampaignManagement={true} cancelEdit={() => setEditCampaign(true)} saveEdit={props.saveEdit}/>
          </div>
        )
      }
      {activeTab === TabStep.Statistics &&
        <div className={'statistics'}>
          <p className={'statisticsTitle'}>Statistics</p>
          <div className={'statisticsSectionsGroup'}>
            <div className={'statisticsSectionWrapper'}>
              <p className={'statisticsLabel'}>Overview</p>
              <div className={'statisticsOverview'}>
                {statisticsItems.slice(0, statisticsItemsNumber).map((item, index) =>
                  <div className={'statisticsOverviewItem'} key={index}>
                    <div className={'statisticsOverviewItemIcon'}>
                      {item.icon}
                    </div>
                    <div className={'statisticsOverviewItemText'}>
                      <p className={'statisticsOverviewItemTitle'}>{item.title}</p>
                      <p className={'statisticsOverviewItemValue'}>{item.value}</p>
                    </div>
                  </div>)}
              </div>
            </div>
            <div className={'statisticsSectionWrapper'}>
              <p className={'statisticsLabel'}>Budget</p>
              <div className={'statisticsBudgetWrapper'}>
                <div className={'statisticsChartWrapper'}>
                  <Chart type="doughnut" data={chartData} options={chartOptions} style={{ width: '140px', height: '140px' }} />
                  <div className={'statisticsChartText'}>
                    <p className={'statisticsChartTextLabel'}>Budget Left</p>
                    <p className={'statisticsChartTextNumber'}>$ {props.campaign?.budget.amountLeft}</p>
                    <p className={'statisticsChartTextPercentage'}>{props.campaign?.budget.amount !== 0 ? Math.ceil(((props.campaign?.budget.amount - props.campaign?.budget.amountLeft) / props.campaign?.budget.amount) * 100) : 0}%</p>
                  </div>
                </div>
                <div className={'exportReportWrapper'}>
                  <Button disabled={true} className={'exportReportButton'}>Export the report</Button>
                  <p className={'exportReportText'}>
                    Export your campaign’s statistics.<br/>
                    Currently under construction.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className={'statisticsLabel'}>Timeline</p>
            <div className={'analyticsWrapper'}>
              <p className={'comingSoonTitle'}>Coming Soon</p>
              <p className={'comingSoonText'}>We will be adding the analytics for your campaigns very soon!</p>
              <Image src={comingSoonImage} alt={'coming soon'} className={'comingSoonImage'}/>
            </div>
          </div>
        </div>
      }
      {activeTab === TabStep.LiveContent &&
        <div className={'liveContent'}>
          <p className={'liveContentTitle'}>Live Content</p>
          <DataTable value={props.liveContentItems} removableSort emptyMessage={"No live content found."} onRowClick={(e) => props.goToContent(e.data.id)}>
            <Column field={"title"} header={"Video"} body={videoBodyTemplate} sortable style={{ width: '40%' }}></Column>
            <Column field={"public"} header={"Status"} body={statusBodyTemplate} sortable style={{ width: '12%' }}></Column>
            <Column field={"createdAt"} header={"Date"} body={dateBodyTemplate} sortable style={{ width: '12%' }}></Column>
            <Column field={"statistics.viewCount"} header={"Views"} body={viewsBodyTemplate} sortable style={{ width: '12%' }}></Column>
            <Column field={"statistics.likeCount"} header={"Likes"} body={likesBodyTemplate} sortable style={{ width: '12%' }}></Column>
            <Column field={"statistics.commentCount"} header={"Comments"} body={commentBodyTemplate} sortable style={{ width: '12%' }}></Column>
          </DataTable>
        </div>
      }
      <Dialog visible={warningCloseModal} onHide={() => setWarningCloseModal(false)} className={'warningModal'}>
        <div className={'warningTopLayer'}>
          <i className="pi pi-times" onClick={() => setWarningCloseModal(false)} style={{ color: '#FFF', fontSize: '16px', cursor: 'pointer' }}/>
        </div>
        <div className={'warningContent'}>
          <p className={'warningTitle'}>You are about to close {props.campaign?.name}!</p>
          <p className={'warningText'}>Are you sure you want to close this campaign?</p>
          <Button onClick={() => props.campaignClosing().then(() => setWarningCloseModal(false))} className={'confirmButton'}>Close campaign</Button>
        </div>
      </Dialog>
      <Dialog visible={warningCopyModal} onHide={() => setWarningCopyModal(false)} className={'warningModal'}>
        <div className={'warningTopLayer'}>
          <i className="pi pi-times" onClick={() => setWarningCopyModal(false)} style={{ color: '#FFF', fontSize: '16px', cursor: 'pointer' }}/>
        </div>
        <div className={'warningContent'}>
          <p className={'warningTitle'}>You are about to copy {props.campaign?.name}!</p>
          <p className={'warningText'}>
            Copying a campaign will replicate the structure and settings, but it is crucial to note that certain data may
            become outdated or irrelevant. To ensure the success of your duplicated campaign, we strongly recommend that you
            carefully review and update all relevant information including campaign description, talking points, imagery, budget, etc.
          </p>
          <Button onClick={() => copyCampaign().then(() => setWarningCopyModal(false))} className={'confirmButton'}>Copy campaign</Button>
        </div>
      </Dialog>
    </div>
  )
}
